<script setup>
  import {ref, defineAsyncComponent, watch, computed} from 'vue'
  import { useIdentificationUpgrade } from '@/composables/useIdentificationUpgrade.js';
  import { navs } from './Navs'

  const RequiredKYCModal = defineAsyncComponent(() =>
      import(/* webpackChunkName: "components/RequiredKYCModalNew" */ '@/components/modals/RequiredKYCModal.vue')
  )
  const IdentificationLevelUpgradeModal = defineAsyncComponent(() =>
      import(/* webpackChunkName: "components/StoreModal" */ '@/components/modals/StoreModal.vue')
  )

  import { useRoute, useRouter } from 'vue-router'
  const route = useRoute()
  const router = useRouter()

  import { useModalsStore } from '@/store/stores/modals'
  const modalsStore = useModalsStore()

  import { useStore } from 'vuex'
  const vuexStore = useStore()

  const notification_open = ref(false)
  vuexStore.dispatch('refreshUserNotifications')

  watch(notification_open, () => {
    if (notification_open) {
      $('body').addClass('active')
    } else {
      $('body').removeClass('active');
    }
  })

   const authInfo = computed(() => {
     return vuexStore.state.authInfo
   })

  const userNotifications = computed(() => {
    return vuexStore.state.userNotifications || []
  })

  const KYCPassed = computed(() => {
    return vuexStore.getters.kycPassed
  })

  function handleRouteClick(path) {
    if (path === 'Payment' && !KYCPassed.value) {
      modalsStore.setModalName('RequiredKYCModal')
    } else {
      bodyRemoveOverflow()
      router.push({ name: path })
    }
  }
  function bodyRemoveOverflow () {
    $('body').removeClass('scanner_active') //TODO не понятно пока зачем мы добавляем и удаляем этот класс
    notification_open.value = false;
  }

  const {
    identificationLevelUpgradeHowtoText,
    upgradeLevel,
    isLoading
  } = useIdentificationUpgrade()

  watch(isLoading, (v) => {
    const howtoText = identificationLevelUpgradeHowtoText.value
    if (!v && howtoText) {
      modalsStore.setModalName('IdentificationLevelUpgradeModal')
    }
  })
</script>

<template>
  <div class="main_container">
    <header class="header">
      <router-link to="/" class="logo">
        <template v-if="envName === 'grok'">
          <img src="@/assets/grok/images/logo.svg" alt="">
        </template>
        <template v-else-if="envName === 'stater'">
          <img src="@/assets/stater/images/logo-short.svg" alt="">
        </template>
        <template v-else-if="envName === 'arvand'">
          <img src="@/assets/arvand/images/logo-rus.svg" alt="">
        </template>
        <template v-else-if="envName === 'prima'">
          <img src="@/assets/prima/images/prima-logo.png" alt="">
        </template>
        <template v-else>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M21.9964 8.37513H17.7618C15.7911 8.37859 14.1947 9.93514 14.1911 11.8566C14.1884 13.7823 15.7867 15.3458 17.7618 15.3484H22V15.6543C22 19.0136 19.9636 21 16.5173 21H7.48356C4.03644 21 2 19.0136 2 15.6543V8.33786C2 4.97862 4.03644 3 7.48356 3H16.5138C19.96 3 21.9964 4.97862 21.9964 8.33786V8.37513ZM6.73956 8.36733H12.3796H12.3831H12.3902C12.8124 8.36559 13.1538 8.03019 13.152 7.61765C13.1502 7.20598 12.8053 6.87318 12.3831 6.87491H6.73956C6.32 6.87664 5.97956 7.20858 5.97778 7.61852C5.976 8.03019 6.31733 8.36559 6.73956 8.36733Z" fill="var(--accent-bg)"/>
            <path opacity="0.4" d="M16.0374 12.2966C16.2465 13.2478 17.0805 13.917 18.0326 13.8996H21.2825C21.6787 13.8996 22 13.5715 22 13.166V10.6344C21.9991 10.2297 21.6787 9.90077 21.2825 9.8999H17.9561C16.8731 9.90338 15.9983 10.8024 16 11.9102C16 12.0398 16.0128 12.1695 16.0374 12.2966Z" fill="var(--accent-bg)"/>
            <circle cx="18" cy="11.8999" r="1" fill="var(--accent-bg)"/>
          </svg>
          <span>E-Wallet</span>
        </template>
      </router-link>
      <nav>
        <ul class="nav_item">
          <li
            v-for="(item, idx) in navs"
            :key="idx"
            :class="`nav_link ${item.class} ${ item.path == route.name ? 'active' : '' }`"
          >
            <div
              class="link"
              @click="handleRouteClick(item.path)"
            >
              <span v-html="item.svg" /> {{ item.name }}
            </div>
          </li>
        </ul>
      </nav>
      <div class="notification-and-profile">
        <router-link
          @click="bodyRemoveOverflow()"
          to="/settings"
          class="header_profile"
        >
          <div class="info">
            <div class="name">
              {{ authInfo?.first_name }}
            </div>
            <div class="profile-type">
              {{ text('profile.identification.profile_type') }}
            </div>
          </div>
          <img src="@/assets/images/avatar.svg" alt="">
        </router-link>
        <div class="notification" to="/">
          <button @click="notification_open = !notification_open" class="notification_in">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M19.3399 14.49L18.3399 12.83C18.1299 12.46 17.9399 11.76 17.9399 11.35V8.82C17.9399 6.47 16.5599 4.44 14.5699 3.49C14.0499 2.57 13.0899 2 11.9899 2C10.8999 2 9.91994 2.59 9.39994 3.52C7.44994 4.49 6.09994 6.5 6.09994 8.82V11.35C6.09994 11.76 5.90994 12.46 5.69994 12.82L4.68994 14.49C4.28994 15.16 4.19994 15.9 4.44994 16.58C4.68994 17.25 5.25994 17.77 5.99994 18.02C7.93994 18.68 9.97994 19 12.0199 19C14.0599 19 16.0999 18.68 18.0399 18.03C18.7399 17.8 19.2799 17.27 19.5399 16.58C19.7999 15.89 19.7299 15.13 19.3399 14.49Z" fill="white"/>
              <path d="M14.8297 20.01C14.4097 21.17 13.2997 22 11.9997 22C11.2097 22 10.4297 21.68 9.87969 21.11C9.55969 20.81 9.31969 20.41 9.17969 20C9.30969 20.02 9.43969 20.03 9.57969 20.05C9.80969 20.08 10.0497 20.11 10.2897 20.13C10.8597 20.18 11.4397 20.21 12.0197 20.21C12.5897 20.21 13.1597 20.18 13.7197 20.13C13.9297 20.11 14.1397 20.1 14.3397 20.07C14.4997 20.05 14.6597 20.03 14.8297 20.01Z" fill="white"/>
            </svg>
            <span v-if="userNotifications.length" class="circle_icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
                <circle cx="3" cy="3" r="3" fill="var(--accent-bg)"/>
              </svg>
            </span>
          </button>

          <div v-if="notification_open" class="notification_list">
            <div class="notification_head">{{text('notifications.title')}}</div>
            <div class="notification_content_wrapper">
              <div v-if="userNotifications.length" class="notification_content">
                <div
                  v-for="(item, idx) in userNotifications"
                  class="notification_item"
                  :key="idx"
                >
                  <div class="top">{{ formatDateTime(item.created_at) }}</div>
                  <div class="bottom">
                    <img src="@/assets/images/calendar_icon.svg" alt="">
                    <div class="right">
                      <div class="right_title">
                        <!-- <div class="title">уведомление</div> -->
                        <div class="time"></div>
                      </div>
                      <right class="content">
                        {{ item.message }}
                      </right>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="empty-list">
                {{ text('common.empty') }}
              </div>
            </div>

            <button @click="notification_open = false" class="notification_foot">
              <span>{{text('notifications.close_btn')}}</span>
              <img src="@/assets/images/close.svg" alt="">
            </button>
          </div>
        </div>
      </div>

    </header>
    <RequiredKYCModal @upgrade="upgradeLevel" />
    <IdentificationLevelUpgradeModal name="IdentificationLevelUpgradeModal">
      <template #body>
        <div class="identification-level-upgrade-modal text" v-html="identificationLevelUpgradeHowtoText"/>
      </template>
    </IdentificationLevelUpgradeModal>
  </div>
</template>

<style lang="scss">
  .identification-level-upgrade-modal.text {
    padding: 12px;

    p {
      margin: revert;
      padding: revert;
    }

    h4 {
      color: #FFF;
      text-align: center;
      font-family: "Rubik", sans-serif;
      font-size: 16px;
      font-weight: 400;
      line-height: 135%;
      margin-top: 24px;
      text-align: left;
    }

    ul {
      margin: revert;
      padding: revert;

      li {
        list-style: square;
        margin: revert;
        padding: revert;
      }
    }
  }
  .header {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 30px;
    padding: 0 40px;
    background: var(--layout-bg);
    border-radius: 24px 24px 0 0;
    border-bottom: 1px solid var(--border-color);

    .logo {
      display: flex;
      align-items: center;
      gap: 8px;
      z-index: 11;
      text-decoration: none;
      span {
        color: var(--text-color-accent);
        font-family: "Rubik", sans-serif;
        font-size: 22px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        letter-spacing: 0.88px;
        white-space: nowrap;
      }
      img {
        max-height: 40px;
      }
    }
    .notification-and-profile {
      display: flex;
      align-items: center;
      gap: 24px;

      .header_profile {
        height: 76px;
        display: flex;
        align-items: center;
        gap: 10px;
        border-radius: 16px;
        position: relative;
        text-decoration: none;

        .info {
          .name {
            font-size: 16px;
            font-weight: 500;
            color: var(--text-color-primary);
            text-align: end;
          }
          .profile-type {
            font-size: 14px;
            font-weight: 400;
            color: var(--text-color-secondary);
            white-space: nowrap;
          }
        }
        img {
          width: 36px;
          height: 36px;
        }

        @media (max-width: 980px) {
          .info {
            display: none;
          }
        }
      }

      .notification {
        height: 76px;
        display: flex;
        align-items: center;
        position: relative;
        cursor: default;
        z-index: 10;

        .notification_in {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          background: var(--element-bg);
          width: 36px;
          height: 36px;
          .circle_icon {
            position: absolute;
            top: -6px;
            right: 3px;
          }
        }

        &_content_wrapper {
          .empty-list {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            color: var(--text-color-secondary);
          }
        }
      }


      .notification .notification_list {
        position: absolute;
        right: 0;
        top: 88px;
        border-radius: 16px;
        border: 1px solid #3B363F;
        background: #262329;
        width: 411px;
      }
      .notification .notification_list .notification_head {
        color: #FFF;
        font-family: "Rubik", sans-serif;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        letter-spacing: 0.36px;
        padding: 18px 0;
        text-align: center;
        border-bottom: 1px solid #312C35;
      }
      .notification .notification_list .notification_content_wrapper {
        padding: 25px 24px;
      }
      .notification .notification_list .notification_content_wrapper .notification_content {
        max-height: 564px;
        padding-right: 24px;
        overflow-y: scroll;
      }
      .notification .notification_list .notification_content_wrapper .notification_content::-webkit-scrollbar {
        width: 4px;
      }
      .notification .notification_list .notification_content_wrapper .notification_content::-webkit-scrollbar-track {
        border-radius: 4px;
        background: #312C35;
      }
      .notification .notification_list .notification_content_wrapper .notification_content::-webkit-scrollbar-thumb {
        border-radius: 4px;
        background: rgba(166, 164, 180, 0.5);
      }
      .notification .notification_list .notification_content_wrapper .notification_content::-webkit-scrollbar-thumb:hover {
        background: rgb(166, 164, 180);
      }
      .notification .notification_list .notification_content_wrapper .notification_content .notification_item {
        text-align: left;
      }
      .notification .notification_list .notification_content_wrapper .notification_content .notification_item .top {
        color: #A6A4B4;
        font-family: "Rubik", sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 135%;
        margin-bottom: 14px;
      }
      .notification .notification_list .notification_content_wrapper .notification_content .notification_item .bottom {
        display: flex;
        align-items: flex-start;
        gap: 12px;
      }
      .notification .notification_list .notification_content_wrapper .notification_content .notification_item .bottom .right .right_title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 6.5px;
      }
      .notification .notification_list .notification_content_wrapper .notification_content .notification_item .bottom .right .right_title .title {
        color: #FFF;
        font-family: "Rubik", sans-serif;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        letter-spacing: 0.36px;
      }
      .notification .notification_list .notification_content_wrapper .notification_content .notification_item .bottom .right .right_title .time {
        color: #A6A4B4;
        text-align: right;
        font-family: "Rubik", sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 135%;
        opacity: 0.5;
      }
      .notification .notification_list .notification_content_wrapper .notification_content .notification_item .bottom .right .content {
        color: #A6A4B4;
        font-family: "Rubik", sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 135%;
        padding-bottom: 29px;
        width: 100%;
        display: block;
        position: relative;
      }
      .notification .notification_list .notification_content_wrapper .notification_content .notification_item .bottom .right .content span {
        color: #FFF;
      }
      .notification .notification_list .notification_content_wrapper .notification_content .notification_item .bottom .right .content::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 14px;
        width: 100%;
        height: 1px;
        border-radius: 10px;
        background: #312C35;
      }
      .notification .notification_list .notification_foot {
        padding: 18px 0;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 6px;
        border-top: 1px solid #312C35;
      }
      .notification .notification_list .notification_foot span {
        color: #A6A4B4;
        font-family: "Rubik", sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 135%;
      }
    }
  }
  .header nav {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 76px;
    border-radius: 16px;
  }
  .header nav .nav_item {
    height: 100%;
    display: flex;
    align-items: center;
    gap: 60px;
  }
  .header nav .nav_link {
    height: 100%;
    display: flex;
    align-items: center;
    position: relative;
  }
  .header nav .nav_link .link {
    gap: 16px;
    display: flex;
    align-items: center;
    text-decoration: none;
    color: #A6A4B4;
    font-family: "Rubik", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    transition: 0.2s linear;
    cursor: pointer;
  }
  .header nav .nav_link .link svg {
    width: 28px;
    height: 28px;
  }
  .header nav .nav_link .link:hover svg path {
    fill: var(--accent-bg);
  }
  .header nav .nav_link.active::after {
    content: "";
    position: absolute;
    border-radius: 4px 4px 0px 0px;
    background: var(--accent-bg);
    width: 28px;
    height: 4px;
    left: 0;
    bottom: 0;
  }
  .header nav .nav_link.active .link svg path {
    fill: var(--accent-bg);
  }
  .header nav .nav_link_payment .link:hover svg path {
    fill: none;
    stroke: var(--accent-bg);
  }
  .header nav .nav_link_account .link:hover svg path {
    fill: none;
    stroke: var(--accent-bg);
  }
  .header nav .nav_link_payment.active .link svg path {
    fill: none;
    stroke: var(--accent-bg);
  }
  .header nav .nav_link_account.active .link svg path {
    fill: none;
    stroke: var(--accent-bg);
  }
  .header nav .nav_link_stroke .link:hover svg path {
    fill: none;
    stroke: var(--accent-bg);
  }
  .header nav .nav_link_stroke.active .link svg path {
    fill: none;
    stroke: var(--accent-bg);
  }

  @media (max-width: 1060px) {
    .header nav .nav_item {
      gap: 27px;
    }
  }

  @media (min-width: 920px) {
    .header nav .nav_link_account {
      display: none;
    }
  }

  @media (max-width: 920px) {
    .header {
      margin: 10px 20px 25px 20px;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: unset;
      border-bottom: none;

      .notification-and-profile {
        .header_profile {
          height: auto;
          z-index: 11;

          .info {
            display: block;
          }
        }

        .notification {
          z-index: 10;
          height: auto;
          padding: 0;
          background-color: transparent;
        }
        .header_profile .notification_list,
        .notification .notification_list {
          top: -10px;
          right: -20px;
          margin: 0;
          width: 100vw;
          height: 100vh;
          z-index: -1;
          border: none;
          border-radius: 0px;
          padding-bottom: 124px;
        }
        .header_profile .notification_list .notification_head,
        .notification .notification_list .notification_head {
          padding-top: 61px;
          border-bottom: none;
          padding-bottom: 0;
        }
        .header_profile .notification_list .notification_foot,
        .notification .notification_list .notification_foot {
          display: none;
        }
        .header_profile .notification_list .notification_content_wrapper,
        .notification .notification_list .notification_content_wrapper {
          padding: 25px 0;
          position: relative;
          height: calc(100% - 106px);
        }
        .header_profile .notification_list .notification_content_wrapper .notification_content,
        .notification .notification_list .notification_content_wrapper .notification_content {
          padding: 0px 20px;
          min-height: auto;
          max-height: none;
          position: relative;
          height: 100%;
        }
        .header_profile .notification_list .notification_content_wrapper .notification_content .notification_item .top,
        .notification .notification_list .notification_content_wrapper .notification_content .notification_item .top {
          font-size: 14px;
        }
        .header_profile .notification_list .notification_content_wrapper .notification_content .notification_item .bottom img,
        .notification .notification_list .notification_content_wrapper .notification_content .notification_item .bottom img {
          width: 38px;
          height: 38px;
        }
        .header_profile .notification_list .notification_content_wrapper .notification_content .notification_item .bottom .right,
        .notification .notification_list .notification_content_wrapper .notification_content .notification_item .bottom .right {
          width: calc(100% - 50px);
        }
        .header_profile .notification_list .notification_content_wrapper .notification_content .notification_item .bottom .right .right_title .title,
        .notification .notification_list .notification_content_wrapper .notification_content .notification_item .bottom .right .right_title .title {
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 135%;
        }
        .header_profile .notification_list .notification_content_wrapper .notification_content .notification_item .bottom .right .right_title .time,
        .notification .notification_list .notification_content_wrapper .notification_content .notification_item .bottom .right .right_title .time {
          font-size: 14px;
        }
        .header_profile .notification_list .notification_content_wrapper .notification_content .notification_item .bottom .right .content,
        .notification .notification_list .notification_content_wrapper .notification_content .notification_item .bottom .right .content {
          font-size: 14px;
        }
        .header_profile .notification_list .notification_content_wrapper .notification_content .notification_item .bottom .right .content span,
        .notification .notification_list .notification_content_wrapper .notification_content .notification_item .bottom .right .content span {
          font-size: 14px;
        }
      }
    }
    .header .account_name {
      display: block;
    }
    .header nav {
      height: 96px;
      padding: 18px 20px 30px 20px;
      width: 100%;
      position: fixed;
      left: 0;
      bottom: 0;
      z-index: 11;
      border-radius: 16px 16px 0 0;
      border: 1px solid #312C35;
      background: var(--layout-bg);
      box-shadow: 0 0 35px 0 rgba(27, 27, 27, 0.05);
    }
    .header nav .nav_link .link {
      flex-direction: column;
      gap: 8px;
      font-size: 10px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      letter-spacing: 0.2px;
    }
    .header nav .nav_link.active::after {
      top: -18px;
      width: 100%;
      border-radius: 0 0 4px 4px;
    }
    .header nav .nav_link_payment.active::after {
      display: none;
    }
    .header nav .nav_link_payment {
      transform: translateY(-37%);
    }
    .header nav .nav_link_payment .link svg path {
      fill: none;
      stroke: #000;
    }
    .header nav .nav_link_payment .link:hover svg path {
      fill: none;
      stroke: #000;
    }
    .header nav .nav_link_payment .link span {
      z-index: 3;
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--accent-bg);
      width: 64px;
      height: 64px;
      border-radius: 50%;
    }
    .header nav .nav_link_payment.active .link svg path {
      fill: none;
      stroke: #000;
    }
  }
</style>